import React from 'react'
import "../Assets/Styles/Home.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import Headimg from "../Assets/Images/solutionheadimg.png";
import Sec1 from "../Assets/Images/Designer life-bro 1.png";
import Sec2 from "../Assets/Images/New idea-bro 1.png";
import Sec3 from "../Assets/Images/Discussion-bro 1.png";
import Email from "../Assets/Images/Emails-bro 1.png";
import { HashLink } from 'react-router-hash-link';
const Home = () => {
  
  return (
    <div style={{backgroundColor:"#fff"}}>
    <section>
      <div className="solutions-header-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-sm-12 d-flex justify-content-center align-item-center flex-column">
              <div>
                <h1>
                Streamline Your Email  <br />{" "}
                  <span style={{ color: "#007bb6" }} >Creation</span>.
                </h1>
                <p className="mt-3 mb-5">
                Craft professional emails effortlessly with our intuitive email tool. Whether you're designing <br /> segmented emails for personalized outreach or promotional emails for broad campaigns, we make the process simple and efficient.
                </p>
                <div>
                    <Link to={"/email"}>
                  <button className="manufacture_hero_solution_btn">
                    Getting Started
                  </button> 
                   </Link>
                   <HashLink smooth to={"#globe"}>
                  <button className="manufacture_hero_learn_solution_btn">
                    Learn More
                  </button>
                  </HashLink>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-sm-12 justify-content-center align-item-center">
              <img src={Headimg} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div className="globe-section" id='globe'>
        <div className="container">
          <h1>
          Collaborate Globally {" "}
            <span style={{ color: "#007bb6" }}>with Ease</span>
          </h1>
          <p>
          Work with clients and teams across the globe effortlessly. Our platform is designed to facilitate smooth communication and collaboration, ensuring that your email campaigns are delivered on time, no matter where your clients are located.
          </p>
          <div className="globe-cards">
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div className="p-5">
                  <div className="globe-tag">
                    <i className="fas fa-check" /> Key Points
                  </div>
                  <h2>Meet deadlines and exceed expectations</h2>
                  <p>
                  Delivering outstanding email campaigns on time is crucial. With PROTON, you can streamline your workflow, meet tight deadlines, and exceed client expectations with ease. Focus on creativity while we handle the efficiency.
                  </p>
                  <a href="#">
                    Learn more <i className="fas fa-arrow-right" />
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-sm-12 ">
                <div className="solution-blue-container">
                  <img src={Sec1} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="globe-cards">
            <div className="row">
              <div className="col-md-6 col-sm-12 ">
                <div className="solution-grey-container">
                  <img src={Sec2} alt="" />
                </div>
              </div>
              <div className="col-md-6 col-sm-12">
                <div className="p-5">
                  <div
                    className="globe-tag"
                    style={{ backgroundColor: "#EDECFE" }}
                  >
                    <i className="fas fa-check" /> Key Points
                  </div>
                  <h2>Secure Your Clients’ Data</h2>
                  <p>Your clients’ data security is our top priority. PROTON ensures that all email content and client information are protected with advanced security measures. Build trust with your clients by safeguarding their sensitive data.</p>
                  <a href="#">
                    Learn more <i className="fas fa-arrow-right" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="globe-cards">
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div className="p-5">
                  <div className="globe-tag">
                    <i className="fas fa-check" /> Key Points
                  </div>
                  <h2>Boost Productivity for Your Team</h2>
                  <p>
                  Keep your team organized and productive with PROTON’s intuitive tools. From creating personalized email templates to managing multiple client campaigns, our platform simplifies the process, so your team can focus on delivering exceptional results.</p>
                  <a href="#">
                    Learn more <i className="fas fa-arrow-right" />
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-sm-12 ">
                <div className="solution-blue-container">
                  <img src={Sec3} alt="" />
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
    <section>
      <div className="secure-solution">
        <div className="container">
          <h1>Efficient Email Campaign Management</h1>
          <p>
          Manage campaigns more effectively, and streamline your workflow with PROTON. Reduce downtime <br /> and improve efficiency, ensuring your clients’ campaigns run smoothly.
          </p>
          <img src={Email} alt="" />
        </div>
      </div>
    </section>
    <section>
      <div className="solution-productive">
        <div className="container">
          <h1>
          Create Emails That  <span style={{ color: "#007bb6" }}>Drive Results</span>
          </h1>
          <p>
          With PROTON, you can effortlessly craft promotional, segmented, (SSGP) emails for your clients. Our tools are designed to <br /> help you deliver impactful campaigns that resonate with your audience and achieve your clients' goals.
          </p>
          <br />
          <div className="row mt-5">
            <div className="col-md-4 col-sm-12">
              <div className="productive-cards">
                <div className="productive-circle">
                  <i className="fas fa-laptop" />
                </div>
                <h3>Promotional Emails</h3>
                <p>
                Boost your clients' sales and engagement with eye-catching promotional emails. Whether it’s a product launch, a seasonal sale, or a special offer, PROTON helps you create compelling campaigns that drive action.{" "}
                </p>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="productive-cards">
                <div className="productive-circle">
                  <i className="fas fa-file" />
                </div>
                <h3>Segmented Emails</h3>
                <p>
                Reach the right audience with precision. PROTON enables you to segment your clients' email lists based on demographics, behavior, or preferences, ensuring that every message is tailored to the right recipient for maximum impact.{" "}
                </p>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="productive-cards">
                <div className="productive-circle">
                  <i className="fas fa-tag" />
                </div>
                <h3>SSGP</h3>
                <p>
                Go beyond generic emails. With PROTON, you can create smart campaigns that adapt to your clients' needs, scale effortlessly as their business grows, and stay goal-oriented to deliver measurable results.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  
  )
}

export default Home